import { cn } from "@/lib/utils";
import dayjs from "dayjs";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface DatePickerEntryValueProps
	extends Omit<BaseEntryValueProps, "value"> {
	value: string | null;
}

export function DatePickerEntryValue({
	value,
	inputLabel,
	size,
	className,
	...props
}: DatePickerEntryValueProps) {
	return (
		<BaseEntryValue
			inputLabel={inputLabel}
			size={size}
			className={className}
			{...props}
		>
			<p
				className={cn(
					size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-base",
				)}
			>
				{dayjs(value).format("DD MMM YYYY")}
			</p>
		</BaseEntryValue>
	);
}
